export default __webpack_public_path__ + "static/banner-standards-2-7906885d8a6f1c374bbf91031dbb8106.jpg";